import { memo, useState } from "react";
import { useSignalRContext } from "../../../SignalR/useSignalR";
import { IconButton, Modal, TableCell, TableRow, Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { EditOrder } from "./EditOrder";
import { useAuth } from "../../../provider/authProvider";


const OrderRow = ({data})=>{
    const {token} = useAuth();
    const { tickData, sendOrderCloseRequest} = useSignalRContext();
    const [openAmmend, setOpenAmmend] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    
    if(!data){
        return (<></>);
    }
    const {
        id,
        clOrderId,
        time,
        expireTime,
        timeInForce,
        type,            
        symbolId,
        symbolName,
        targetPrice,
        volume,
        tradeSide,
        stopLoss,
        takeProfit
    } = data;
    const tickIndex = tickData.findIndex((item) => item?.symbolId === symbolId);
    //if(tickIndex > -1){
    const quote = tickData[tickIndex]; 
    //const handleAmmendOpen=()=>{}
    const handleAmmendClose=()=>{
        setOpenAmmend(false);
    }
    const handleAmmend = ()=>{
        console.log("Ammend order");
        setOpenAmmend(true);
    }
    const handleDelete = (data)=>{
        console.log("Delete order");
        sendOrderCloseRequest(token, clOrderId, id)
    }
    return (
        <>
        <TableRow
                    sx={{
                        "& .MuiTableCell-root": {
                        borderBottom: "none",
                        px: 1,
                        py: 1.5,
                        },
                        backgroundColor: "primary.main",
                        borderRadius: "4px",
                        "& td:first-of-type": {
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                        borderTopRightRadius: "",
                        borderBottomRightRadius:  "",
                        },
                        "& td:last-child": {
                        borderTopRightRadius:  "6px",
                        borderBottomRightRadius: "6px",
                        borderTopLeftRadius:  "",
                        borderBottomLeftRadius: "",
                        },
                        "&:hover": {
                        backgroundColor: "tertiary.main",
                        },
                    }}
                >
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {id}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {clOrderId}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {time}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                            {symbolName}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                            {tradeSide}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                            {type}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                            {volume}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                            {targetPrice}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {
                            (tradeSide === "Buy"
                            ? quote?.ask
                            : quote?.bid).toFixed(quote?.digits)
                        }
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                            {expireTime}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <IconButton aria-label="edit" color="white" size="small" onClick={handleAmmend}>
                            <EditIcon />
                        </IconButton>
                    </TableCell>
                    <TableCell>
                        <IconButton aria-label="delete" color="white" size="small" onClick={handleDelete}>
                            <DeleteIcon />
                        </IconButton>
                    </TableCell>
                    
                    
        </TableRow>  
        <Modal
            open={openAmmend}
            onClose={handleAmmendClose}>
                <EditOrder data={data}/>
                </Modal>  
        </> 
    );
}

export default memo(OrderRow);